var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveToFolder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0957 3.5C5.28683 3.5 5.46705 3.59099 5.58008 3.74512L6.32031 4.75488C6.43328 4.90886 6.61275 4.99989 6.80371 5H12.4004C12.7315 5.00021 12.9998 5.26855 13 5.59961V11.9004L12.9883 12.0205C12.9404 12.2553 12.7553 12.4404 12.5205 12.4883L12.4004 12.5H3.59961C3.30966 12.4998 3.06745 12.294 3.01172 12.0205L3 11.9004V4.09961C3.00021 3.76855 3.26855 3.50021 3.59961 3.5H5.0957ZM4 11.5H12V6H6.80371C6.29416 5.99989 5.81501 5.75661 5.51367 5.3457L4.89355 4.5H4V11.5Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07077 6.76831C8.23329 6.76842 8.38945 6.83503 8.50241 6.9519L9.68893 8.17944C9.91893 8.41757 9.91203 8.7978 9.67428 9.02808C9.43598 9.25833 9.0559 9.25172 8.82565 9.01343L8.67038 8.85327V10.1316C8.67038 10.4628 8.40195 10.731 8.07077 10.7312C7.73939 10.7312 7.47018 10.463 7.47018 10.1316V8.85425L7.31588 9.01343C7.08563 9.25173 6.70556 9.25833 6.46725 9.02808C6.22905 8.79781 6.22238 8.41771 6.4526 8.17944L7.63912 6.9519C7.75216 6.8351 7.90822 6.76831 8.07077 6.76831Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveToFolder2);
export default __webpack_public_path__ + "static/media/Move_to_folder_2.fe9c421cb04d00647e1d7f585e52cf3b.svg";
export { ForwardRef as ReactComponent };